module.exports = __webpack_public_path__ + "img/ImgC1.ec20aaff.jpeg";